import { Helmet } from 'react-helmet-async';

import AdminEnrollmentsTable from './admin-enrollments-table';



// ----------------------------------------------------------------------

export default function AdminEnrollmentsPage() {
  return (
    <>
      <Helmet>
        <title>Credentials</title>
      </Helmet>
      <AdminEnrollmentsTable/>
    </>
  );
}
